import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { Typography } from '@doltech/ui/lib/figma/DesignSystemV2/Typography';
import { SkillEnum } from '@doltech/utils/lib/constants';
import * as React from 'react';
import styled from 'styled-components';

import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import { useBookSEOPageContext } from '../../BookSEOPageContext';
import cl from 'classnames';

import { CardOnlineTest } from '../CardOnlineTest/CardOnlineTest';

const TestRecord = styled.div`
  display: grid;
  grid-template-columns: 180px 270px 270px;
  place-items: center;
  &:not(:last-child) {
    border-bottom: 1px solid ${colorsV2.gray20};
  }
  .test-name {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid ${colorsV2.gray20};
  }

  .test-item {
    padding: 28px 24px;
  }
`;

const Main = styled.div`
  .table-header {
    text-align: center;
    background: ${colorsV2.gray5};
    display: grid;
    grid-template-columns: 180px 270px 270px;
    .title {
      padding: 12px 0;
      &:first-child {
        border-right: 1px solid ${colorsV2.gray20};
      }
    }
  }

  &.one-col {
    .table-header {
      grid-template-columns: 180px minmax(0, 1fr);
    }
    ${TestRecord} {
      grid-template-columns: 180px 1fr;
    }
  }
`;

export const FullTestTableDesktop = () => {
  const { bookDetail } = useBookSEOPageContext();

  const testsGroupedByNameObject = bookDetail.tests.reduce((result, item) => {
    const key = item.name;
    if (!result[key]) {
      result[key] = [];
    }
    if (item.skill === SkillEnum.READING) {
      result[key][0] = item;
    } else {
      result[key][1] = item;
    }
    return result;
  }, {});

  const testsGroupedByName = Object.keys(testsGroupedByNameObject).reduce((result, key) => {
    result.push(testsGroupedByNameObject[key]);
    return result;
  }, []);

  const existingReading = testsGroupedByName.filter((test) => test[0])?.length > 0;
  const existingListening = testsGroupedByName.filter((test) => test[1])?.length > 0;

  return (
    <Main className={cl({ 'one-col': !existingReading || !existingListening })}>
      <div className="table-header">
        <ResponsiveTypography.Paragraph
          color="black100"
          className="title"
          variant="semi-bold/20-28"
        >
          BÀI TEST
        </ResponsiveTypography.Paragraph>
        {existingReading && (
          <ResponsiveTypography.Paragraph
            color="black100"
            className="title"
            variant="semi-bold/20-28"
          >
            READING
          </ResponsiveTypography.Paragraph>
        )}

        {existingListening && (
          <ResponsiveTypography.Paragraph
            color="black100"
            className="title"
            variant="semi-bold/20-28"
          >
            LISTENING
          </ResponsiveTypography.Paragraph>
        )}
      </div>
      <div className="body">
        {testsGroupedByName.map((tests) => {
          return (
            <TestRecord key={tests[0]?.name || tests[1]?.name}>
              <div className="test-name">
                <Typography.Title level={2} variant="semi-bold/16-24" color="black100">
                  {tests[0]?.name || tests[1]?.name}
                </Typography.Title>
              </div>
              {tests[0] && <CardOnlineTest test={tests[0]} skill={SkillEnum.READING} />}
              {tests[1] && <CardOnlineTest test={tests[1]} skill={SkillEnum.LISTENING} />}
            </TestRecord>
          );
        })}
      </div>
    </Main>
  );
};
